import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthService } from 'src/app/shared/services/auth.service';
import { RNTFuncionarioEntry } from 'src/app/shared/entrys/rnt-funcionario.entry';
import { DatoPaginadoModel, Paging } from 'src/app/shared/models/dato-paginado.model';
import { DataSharedService } from 'src/app/shared/services/data-shared.service';
import { Router } from '@angular/router';
import { DatoSolicitudSharedModel } from 'src/app/shared/models/dato-solicitud-shared.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalConfirmarRespuestaComponent } from 'src/app/shared/layouts/modal-confirmar-respuesta/modal-confirmar-respuesta.component';
import { ConfirmarRespuestaModel, ConfirmarRespuestaType } from 'src/app/shared/models/confirmar-respuesta.model';
import { EstablecimientoComercioService } from '../../prestador/establecimiento-comercio/establecimiento-comercio.service';
import { RNTPrestadorEntry } from 'src/app/shared/entrys/rnt-prestador.entry';
import { EstadosRnt } from 'src/app/shared/enumeraciones/estados-rnt.enum';
import { RolesUsuario } from 'src/app/shared/enumeraciones/roles-usuario.enum';
import { CamaraComercioEntry } from 'src/app/shared/entrys/camara-comercio';
import { RntConsultaService } from './rnt-consulta.service';
import { RntService } from '../rnts/rnt.service';
import { AlertsService } from '../../../../../../shared/services/alerts.service';
import { ModalHistorialDetalleProcesoComponent } from 'src/app/components/core/layouts/modal-historial-detalle-proceso/modal-historial-detalle-proceso.component';
import { MensajesUsuario } from 'src/app/shared/enumeraciones/mensajes-usuario.enum';
import { ModalSeleccionFuncionarioComponent } from 'src/app/components/core/layouts/modal-seleccion-funcionario/modal-seleccion-funcionario.component';

@Component({
	selector: 'app-rnt-consulta',
	templateUrl: './rnt-consulta.component.html',
	styleUrls: ['./rnt-consulta.component.scss']
})
export class RntConsultaComponent implements OnInit {

	headers: string[] = [];
	solicitudes: Array<RNTFuncionarioEntry>;
	formFiltroSolicitud: FormGroup;
	dataTabla: DatoPaginadoModel;
	estados_solicitud: Array<any>;
	estados_rnt: Array<any>;
	estado_activo = EstadosRnt.Activo;
	estado_activo_2 = EstadosRnt.PendientePorRenovar;
	public isCollapsed = true;
	tipo_funcionario = RolesUsuario.Funcionario;
	adminSuper = RolesUsuario.AdministradorSuper;
	soloConsultaNacional = RolesUsuario.SoloConsultaNacional;
	userLogin: boolean;
	paginaActual: number;
	camarasLista: Array<CamaraComercioEntry>;
	constructor(private formBuilder: FormBuilder, private router: Router, private rntService: RntService,
		private rntConsultaService: RntConsultaService, public authService: AuthService,
		private dataSharedService: DataSharedService, private modalService: NgbModal, private alertsService: AlertsService,
		private establecimientoComercioService: EstablecimientoComercioService) {
		this.dataTabla = {
			paging: {} as Paging
		} as DatoPaginadoModel;
		this.userLogin = authService.isToken();
		this.paginaActual = 1;
	}

	ngOnInit() {
		this.headers = ['Número RNT', 'Tipo RNT', 'Tipo solicitud', 'Fecha Radicado', 'Estado solicitud', 'Establecimiento',
			'Fecha última actualización', 'Matricula', 'Detalle del proceso', 'NIT', 'Radicado', 'Funcionario', 'Acciones'];
		this.formFiltroSolicitud = this.formBuilder.group({
			codigo_rnt: [null],
			numero_radicacion: [null],
			estado_solicitud_id: [null],
			estado_rnt_id: [null],
			nit: [null],
			matricula: [null],
			codigo_camara: [null],
			usuario_funcionario: [null],
			usuario_id_funcionario: [null]
		});
		this.onFiltrar();
		this.onEstadosSolicitudes();
		this.onEstadosRnt();
		this.establecimientoComercioService.getCamaras().subscribe(resultado => {
			if (resultado) {
				this.camarasLista = resultado.data as Array<CamaraComercioEntry>;
			}
		});
	}

	onFiltrar() {
		this.paginaActual = 1;
		this.rntConsultaService.getSolicitudes(1, this.formFiltroSolicitud.value).subscribe(resultado => {
			if (resultado.result) {
				this.dataTabla = resultado.data as DatoPaginadoModel;
				this.solicitudes = this.dataTabla.items as Array<RNTFuncionarioEntry>;
			}
		});
	}

	onPaginado(value: number) {
		this.paginaActual = value;
		this.rntConsultaService.getSolicitudes(value, this.formFiltroSolicitud.value).subscribe(resultado => {
			if (resultado.result) {
				this.dataTabla = resultado.data as DatoPaginadoModel;
				this.solicitudes = this.dataTabla.items as Array<RNTFuncionarioEntry>;
			}
		});
	}

	onAcciones(solicitudes: RNTFuncionarioEntry) {
		this.dataSharedService.sharedData(<DatoSolicitudSharedModel>{
			data: solicitudes,
			tipo_rnt: solicitudes.tipo_rnt_id
		});
		this.router.navigate(['detalle-solicitud/establecimientos']);
	}
	onReporte(rntPrestadorEntry: RNTPrestadorEntry) {
		this.establecimientoComercioService.getExpedirCertificadoRegistroPorRnt(rntPrestadorEntry).subscribe(resultado => {
			const url = window.URL.createObjectURL(resultado);
			window.open(url);
		});
	}
	onCertificado(rntPrestadorEntry: RNTPrestadorEntry) {
		this.establecimientoComercioService.getExpedirCertificadoPorRnt(rntPrestadorEntry)
			.subscribe(resultado => {
				const url = window.URL.createObjectURL(resultado);
				window.open(url);
			});
	}
	onAccionesAsignar(solicitudes: RNTFuncionarioEntry) {
		this.dataSharedService.sharedData(<DatoSolicitudSharedModel>{
			data: solicitudes,
			tipo_rnt: solicitudes.tipo_rnt_id
		});
		const modalRef = this.modalService.open(ModalConfirmarRespuestaComponent, { centered: true });
		const confirmarRespuesta = {} as ConfirmarRespuestaModel;
		confirmarRespuesta.type = ConfirmarRespuestaType.Atencion;
		confirmarRespuesta.message = '¿Está seguro de asignarse la solicitud seleccionada?';
		modalRef.componentInstance.confirmarRespuesta = confirmarRespuesta;
		modalRef.result.then(() => {
			this.rntConsultaService.sendAsignacion(solicitudes).subscribe(result => {
				if (result.result) {
					this.onFiltrar();
				}
			});
		});
	}

	onEstadosSolicitudes() {
		this.rntConsultaService.getEstadosSolicitudes().subscribe(resultado => {
			if (resultado.result) {
				this.estados_solicitud = resultado.data;
			}
		});
	}

	onEstadosRnt() {
		this.rntConsultaService.getEstadosRnt().subscribe(resultado => {
			if (resultado.result) {
				this.estados_rnt = resultado.data;
			}
		});
	}
	onAnotacion(rntPrestadorEntry: RNTPrestadorEntry) {
		this.dataSharedService.sharedData(<DatoSolicitudSharedModel>{
			data: rntPrestadorEntry
		});
		this.router.navigate(['anotacion']);
	}
	onOpenModalFuncionario() {
		const modalRef = this.modalService.open(ModalSeleccionFuncionarioComponent,
			{ centered: true, size: 'lg', backdropClass: 'light-blue-backdrop', windowClass: 'modal-customer-xl' });
		modalRef.result.then(resultado => {
			this.formFiltroSolicitud.get('usuario_funcionario').patchValue(resultado.usuario);
			this.formFiltroSolicitud.get('usuario_id_funcionario').patchValue(resultado.usuario_id);
		}).catch(resultado => {
			this.formFiltroSolicitud.get('usuario_funcionario').patchValue(null);
			this.formFiltroSolicitud.get('usuario_id_funcionario').patchValue(null);
		});
	}
	reset() {
		this.formFiltroSolicitud.reset();
		this.onFiltrar();
	}
	modalDetalleProceso(rntId) {
		this.rntService.historialDetalleProceso(rntId).subscribe((response) => {
			if (response.result) {
				const modalRef = this.modalService.open(
					ModalHistorialDetalleProcesoComponent,
					{
						centered: true,
						size: "lg",
						backdropClass: "light-blue-backdrop",
					}
				);
				modalRef.componentInstance.rntId = rntId;
			} else {
				this.alertsService.error(
					MensajesUsuario.Errorgeneral,
					null,
					null
				);
			}
		});
	}
}
